import React from 'react';
const MessageSvgImage =()=>{
        return(<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="15px" viewBox="0 0 22 15" enableBackground="new 0 0 22 15" xmlSpace="preserve"> <g> <polygon fill="#6889be" points="11.505,9.369 22,1.473 22,0 0,0 0,1.43   "></polygon> <polygon fill="#6889be" points="11.557,11.849 0,3.874 0,15 22,15 22,3.993   "></polygon> </g> </svg>)
}
export default MessageSvgImage;
        
